export const OS_VERSION_REPORT_ID = 'os-version';
